import React from "react";

import { useTranslation, useUpdateFarmSetting } from "utils";

import { COUNTRY_CODE } from "consts";

import { AlertBanner, Button, Flex, Modal, Typography, WidgetVideo } from "components";

import { HISTORICAL_PRACTICE_EXPLAINER_VIDEO_VIMEO_URL } from "pages/app/historical-practice-data-table-view/HistoricalPracticeDataTableView";

export const InterventionRetentionMessageModal = ({ isOpen, setIsOpen }: { isOpen: boolean; setIsOpen: (isOpen: boolean) => void }) => {
  const { t } = useTranslation(["allFieldView", "historicalPracticeDataTableView"]);
  const { mutate: mutateFarmSetting } = useUpdateFarmSetting();

  const handleConfirm = () => {
    mutateFarmSetting({ item: "interventionRetentionMessageModalDismissed", value: "true" });
    setIsOpen(false);
  };

  return (
    <Modal
      className="intervention-retention-message-modal"
      open={isOpen}
      onCancel={() => setIsOpen(false)}
      footer={
        <Flex justify="center" align="center" style={{ width: "100%" }}>
          <Button type="primary" onClick={handleConfirm} style={{ maxWidth: "min-content", minWidth: "12rem" }}>
            {t("interventionRetentionMessageModal.getStarted")}
          </Button>
        </Flex>
      }
      content={
        <Flex vertical justify="center" align="center" gap="2rem" className="intervention-retention-message-modal-container">
          <Flex vertical gap="1.5rem">
            <Flex vertical gap="0.5rem">
              <Typography variant="h1" className="intervention-retention-message-modal-title">
                {t("interventionRetentionMessageModal.title")}
              </Typography>
              <Typography variant="paragraph-m" className="intervention-retention-message-modal-description">
                {t("interventionRetentionMessageModal.description")}
              </Typography>
            </Flex>
            <AlertBanner
              title={t("interventionRetentionMessageModal.banner.title")}
              description={t("interventionRetentionMessageModal.banner.description")}
              type="recommended"
              isTitleBold={true}
              headingSize="paragraph-s"
              descriptionSize="paragraph-s"
              gap={8}
              iconName="tabler/bulb"
              iconSize={16}
              iconAlign="start"
            />
            <WidgetVideo
              vimeoUrlOrId={HISTORICAL_PRACTICE_EXPLAINER_VIDEO_VIMEO_URL}
              title={t("historicalPracticeDataTableView:sidePanel.explainer.title")}
              description={t("historicalPracticeDataTableView:sidePanel.explainer.description")}
              allowedCountries={[COUNTRY_CODE.GERMANY]}
            />
          </Flex>
        </Flex>
      }
    />
  );
};
